import { useEffect, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import {
  EyeBlinkKey,
  IdProps,
} from '~/components/ChatAvatar/Canvas/Character/RobotCharacter';
import useChatAvatarStore from '~/store/useChatAvatarStore';

const useRandomEyeBlink = ({ id }: IdProps) => {
  const morphs = useChatAvatarStore((state) => state.character?.[id]?.morphs);
  const [blink, setBlink] = useState(false);

  useEffect(() => {
    let blinkTimeout: any;
    const nextBlink = () => {
      blinkTimeout = setTimeout(() => {
        setBlink(true);
        setTimeout(() => {
          setBlink(false);
          nextBlink();
        }, 200);
      }, THREE.MathUtils.randInt(1000, 5000));
    };
    nextBlink();
    return () => clearTimeout(blinkTimeout);
  }, []);

  useFrame(() => {
    EyeBlinkKey.forEach((target) => {
      morphs?.forEach((morph) => {
        const index = morph.morphTargetDictionary[target];

        if (index) {
          morph.morphTargetInfluences[index] = THREE.MathUtils.lerp(
            morph.morphTargetInfluences[index],
            blink ? 1 : 0,
            0.5,
          );
        }
      });
    });
  });
};

export default useRandomEyeBlink;
